import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import ButtonsWidget from './ButtonsWidget.jsx';
import imageLeftSVG from '@plone/volto/icons/image-left.svg';
import imageRightSVG from '@plone/volto/icons/image-right.svg';
import imageFitSVG from '@plone/volto/icons/image-fit.svg';

const messages = defineMessages({
  left: {
    id: 'Left',
    defaultMessage: 'Left',
  },
  right: {
    id: 'Right',
    defaultMessage: 'Right',
  },
  center: {
    id: 'Center',
    defaultMessage: 'Center',
  },
});

export const defaultActionsInfo = ({ intl }) => ({
  left: [imageLeftSVG, intl.formatMessage(messages.left)],
  right: [imageRightSVG, intl.formatMessage(messages.right)],
  center: [imageFitSVG, intl.formatMessage(messages.center)],
});

const AlignWidget = (props) => {
  const intl = useIntl();

  const actions = ['left', 'right', 'center'];

  const actionsInfo = {
    ...defaultActionsInfo({ intl }),
  };

  const disable = props.disable;
  return (
    <ButtonsWidget
      {...props}
      disable={disable}
      actions={actions}
      actionsInfoMap={actionsInfo}
      defaultAction={props.defaultAction || 'center'}
    />
  );
};

export default AlignWidget;
